module.exports = __webpack_public_path__ + "assets/images/project/meta.jpg?v=5f8056cb";